import { CloseButton } from "../../CloseButton";
import { Text } from "../../Base";
import { View } from "../../View";
import { makeStyles } from "@mui/styles";
import { memo } from "react";
import { setSelectedCollection } from "../../../reducers/matrixProfile";
import { useDispatch } from "react-redux";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  text: {
    fontSize: "18px",
  },
});

export const PopUpHeader = memo(() => {
  const styles = useStyles();
  const dispatch = useDispatch();

  return (
    <View className={styles.container}>
      <Text className={styles.text}>Collection</Text>
      <CloseButton
        onClose={() => {
          dispatch(setSelectedCollection(null));
        }}
        dark={false}
      />
    </View>
  );
});
